module.exports = __webpack_public_path__ + "static/media/3.a57c2ad7.mp4";